export default __webpack_public_path__ + "static/media/profile-green-bar-small.1f18d837.png";